import moment from 'moment';
import TradeOrganization from '../tradeOrganization/TradeOrganization.vue';
import ViewImgComponent from '../components/view-img.vue';
import FileUploader from '../components/file-uploader.vue';
import QrCodeScanner from '../../../components/QrCodeScanner.vue';

const check3Months = (val) => {
  const date = moment(val, 'DD.MM.YYYY', true);

  if (!date.isValid()) {
    return false;
  }
  date.add(1, 'day');

  return moment().diff(date, 'months', true) <= 3;
};

export default {
  props: ['action_id', 'id'],
  components: { TradeOrganization, ViewImgComponent, FileUploader, QrCodeScanner },
  data() {
    return {
      saleID: this.$props.id,
      actionID: this.$props.action_id,
      showHistory: false,
      qrcode: null,
      valid: false,
      photos: [],
      saleDateMenu: '',
      saleTimeMenu: '',
      sold_on: '',
      sold_on_local: '',
      time: null,
      date_setup: '',
      date_setup_local: '',
      product_id: null,
      group_id: null,
      category_id: null,
      other_category_id: null,
      checkDifferentWide: false,
      checkSum: '',
      fnCheckNumber: '',
      fdCheckNumber: '',
      fpCheckNumber: '',
      nCheckNumber: '1',
      scanQrCode: {
        openModal: false,
      },
      positions: [],
      // showHistory: false,
      //   address: '',
      //   address_data: {},
      //   dealer__dont_check
      //   cities: [],
      //   city_id: null,
      //   region_id: null,
      //   suggestions: [],
      //   productsSelected: [],
      //   product: '',
      //   number: '',
      //   dateModal: false,
      //   bonuses: {
      //     total: 0,
      //     plan: null,
      //     fact: 0,
      //     unit: '',
      //   },
      //   defaultImage: { ...defaultImage },
      //   defaultPosition: { ...defaultPosition },
      //   tradeOrganizationId: null,
      //   tradeOrganization: {},
      //   installation_data: [],
      //   installation_models: [],
      //   modelIsBlocked: true,
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        check3Months: value => check3Months(value) || 'Чек не должен быть старше 3-х месяцев',
      },
    };
  },
  watch: {
    sold_on(val) {
      this.sold_on_local = val && this.formatDate(val);
    },
    date_setup(val) {
      this.date_setup_local = val && this.formatDate(val);
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    action() {
      return this.$store.state.sales.action;
    },
    categories() {
      return this.$store.state.sales.categories.sort((a, b) => (a.name > b.name ? 1 : -1)) || [];
    },
    groups() {
      return this.$store.state.sales.groups.sort((a, b) => (a.name > b.name ? 1 : -1)) || [];
    },
    products() {
      return this.$store.state.sales.products.sort((a, b) => (a.name > b.name ? 1 : -1)) || [];
    },
    // isAuthenticated() {
    //   return this.$store.getters.isAuthenticated;
    // },
    loading() {
      return this.$store.state.loading;
    },
    // isEnabled() {
    //   return !!this.name && !!this.email && !!this.phone && !!this.message;
    // },
    sale() {
      return this.$store.state.sales.sale;
    },

    isShowDraftButton() {
      return !this.$store.state.sales.sale?.id || this.$store.state.sales.sale?.status === 'draft';
    },
    // groups() {
    //   return this.$store.state.sales.groups;
    // },
    // productsList() {
    //   return this.action && this.action.products.length
    //     && this.action.products.map(item => item.name);
    // },
    // products() {
    //   const { action } = this.$store.state.sales;
    //   if (action !== null) {
    //     return action.products;
    //   }
    //   return [];
    // },
    // bonuses_formula() {
    //   if (this.$store.state.sales.action != null) {
    //     return this.$store.state.sales.action.bonuses_formula;
    //   }
    //   return 1;
    // },
    //
    validationForm() {
      return this.photos.length > 0 && this.sold_on && this.product_id
        && this.group_id && this.category_id
        && (this.checkDifferentWide ? this.other_category_id : true);
    },

    // validationProduct() {
    //   return !!(this.installation.series && this.installation.model && this.installation.code);
    // },
    isEditable() {
      return this.saleID === 'null' || !!(
        this.sale && this.sale.action.is_actual
        && (this.sale.status === 'draft'
          || this.sale.status === 'redo'
        )
      );
    },
  },
  methods: {
    /**
     * Получение чека
     * @param qrcode
     */
    detectQr(qrcode) {
      this.$store.getters.axl.post('fns/api/tickets/is-valid', { qrcode: qrcode.toLowerCase(), sale_id: this.saleID })
        .then((response) => {
          const date = moment(response.data.t);
          this.fdCheckNumber = response.data.fd;
          this.fnCheckNumber = response.data.fn;
          this.fpCheckNumber = response.data.fp;
          this.nCheckNumber = response.data.n;
          this.checkSum = response.data.s;
          this.sold_on = date.format('YYYY-MM-DD');
          this.time = date.format('HH:mm');
          this.qrcode = qrcode.toLowerCase();
        })
        .catch(error => this.$store.dispatch('HandleError', error))
        .finally(() => {
          this.scanQrCode.openModal = false;
        });
    },
    stopQrScan(error) {
      this.$store.dispatch('ShowErrorMessage', error);
      this.scanQrCode.openModal = false;
    },

    // addPosition() {
    //   this.positions = [...this.positions, { ...this.defaultPosition }];
    // },
    // deletePosition(idx) {
    //   this.positions.splice(idx, 1);
    // },
    // getRegions() {
    //   const app = this;
    //   app.isLoading = true;
    //   return app.$store.getters.ax.post('local-location/api/regions/list')
    //     .then((response) => {
    //       if (response.data.regions !== null && Array.isArray(response.data.regions)
    //         && response.data.regions.length) {
    //         app.regions = response.data.regions;
    //       }
    //     }).catch((error) => {
    //       app.$store.dispatch('HandleError', error);
    //     })
    //     .finally(() => {
    //       app.isLoading = false;
    //     });
    // },
    // getCities() {
    //   const app = this;
    //   app.isLoading = true;
    //   return app.$store.getters.ax.post('local-location/api/cities/list', {
    //    region_id: this.region_id
    //   })
    //     .then((response) => {
    //       if (response.data.cities !== null && Array.isArray(response.data.cities)
    //         && response.data.cities.length) {
    //         app.cities = response.data.cities;
    //       }
    //     }).catch((error) => {
    //       app.$store.dispatch('HandleError', error);
    //     })
    //     .finally(() => {
    //       app.isLoading = false;
    //     });
    // },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    /** Открыть диалог прикрепления фото */
    SetPhoto(photo) {
      const item = { ...photo };
      item.idx = Date.now().toString();
      this.photos = [...this.photos, item];
      // const newPhotos = this.photos.map(i => i);
      // newPhotos.push(photo);
      // this.$set(this.$data, 'photos', newPhotos);
    },
    /**
     * Удаление документа из списка прикрепленных файлов.
     * @param idx номер в списке документов.
     */
    RemoveImg(idx) {
      this.photos = this.photos.filter(item => item.idx !== idx);
    },
    /** Установка предзагруженных значений при редактировании продажи. */
    setDataPreload() {
      const app = this;
      if (app.sale) {
        this.photos = [...app.sale.documents];
        this.sold_on = app.sale.sold_on ? moment(app.sale.sold_on).format('YYYY-MM-DD') : '';
        // eslint-disable-next-line no-useless-escape
        this.time = app.sale.qrcode_t ? app.sale.qrcode_t.replace('\.', ':') : app.sale.qrcode_t;
        this.checkSum = app.sale.qrcode_s;
        this.fnCheckNumber = app.sale.qrcode_fn;
        this.fdCheckNumber = app.sale.qrcode_i;
        this.fpCheckNumber = app.sale.qrcode_fp;
        this.nCheckNumber = app.sale.qrcode_n;


        const { positions } = app.sale;

        if (positions.length > 0) {
          this.product_id = positions[0].product_id;
          this.group_id = positions[0].group_id;
          this.category_id = positions[0].category_id;

          this.checkDifferentWide = positions[0].quantity === 2;

          if (this.checkDifferentWide) {
            this.other_category_id = positions[1].category_id;
          }
        }
      }
    },
    /** Метод добавления новой продажи. */
    onSubmit(isDraft = false) {
      const app = this;
      let restURL = 'sales/api/sale/create';

      const sale = {
        profile_id: this.user.profile_id,
        documents: this.photos,
        sold_on_local: this.sold_on_local,
        qrcode_t: this.time,
        qrcode_s: this.checkSum,
        qrcode_fn: this.fnCheckNumber,
        qrcode_i: this.fdCheckNumber,
        qrcode_fp: this.fpCheckNumber,
        qrcode_n: this.nCheckNumber,
        action_id: this.actionID,
        positions: [],
        register_type: 'web',
      };

      sale.positions.push({
        product_id: this.product_id,
        group_id: this.group_id,
        category_id: this.category_id,
        quantity: this.checkDifferentWide ? 2 : 4,
      });

      if (this.checkDifferentWide) {
        sale.positions.push({
          product_id: this.product_id,
          group_id: this.group_id,
          category_id: this.other_category_id,
          quantity: 2,
        });
      }

      if (app.saleID !== 'null') {
        restURL = 'sales/api/sale/update';
        sale.sale_id = app.sale.id;
        sale.action_id = app.sale.action_id;
      }

      let msg = 'Продажа отправлена на проверку';
      if (isDraft) {
        sale.is_draft = true;
        msg = 'Черновик сохранен';
      }

      app.$store.getters.axl.post(restURL, sale)
        .then(async () => {
          await app.$router.push('/sales/');
          await app.$store.dispatch('ShowInfo', msg);
        })
        .catch(async (error) => {
          await app.$store.dispatch('HandleError', error);
        });
    },
  },
  created() {
    if (this.actionID !== 'null') {
      this.$store.dispatch('sales/GetAction', {
        action_id: +this.actionID,
      });
    }
    if (this.saleID !== 'null') {
      this.$store.dispatch('sales/GetSale', {
        profile_id: this.user.profile_id,
        sale_id: this.saleID,
      })
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          this.setDataPreload();
        });
    }
  },
  mounted() {
  },
};
